// extracted by mini-css-extract-plugin
module.exports = {"tips":"tips-module--tips--11MJG","center":"tips-module--center--2cXrU","tip":"tips-module--tip--30Sax"};